
export default {
  name: 'Footer'
}
